
export default {
  name: 'Footer'
}
